// Utility to fetch workbook modules for a given userId
// Usage: fetchWorkbookModules({ auth, userId, setWorkbookModuleList, setPage, store, logException, callApi })

export const fetchWorkbookModules = async ({ auth, userId, setWorkbookModuleList, setPage, store, logException, callApi }) => {
  try {
    store.setLoading(true);
    let modules = [];
    store.setSearching(true);
    let workbookModules = await callApi(auth, 'seniorplan/details/' + userId, 'GET');
    if (workbookModules.result) {
      workbookModules.result.forEach((w) => {
        w.modules.forEach((m) => {
          modules.push(m);
        });
      });
      setWorkbookModuleList(modules);
    }
    store.setSearching(false);
    store.setLoading(false);
    setPage('workbook');
  } catch (err) {
    logException(err);
    store.setLoading(false);
    console.error(err);
  }
};
